module.exports = __webpack_public_path__ + "static/img/2022620358521851191.1b9165b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UploadFile/1/Img/2022620358521851191.png
// module id = yRRE
// module chunks = 1